import { CreatorRankingPage } from './Ranking/CreatorRankingPage';

export const creatorRoute = {
  '/@/creator/ranking/:tab_name': CreatorRankingPage,
};
